import styled from "styled-components";

const EmployeesSearchWrapper = styled.div`
  padding: 20px 20px 10px 20px;
  max-width: calc(100vw - 770px);
  .ant-table-row-expand-icon {
    display: none;
  }
`;

export default EmployeesSearchWrapper;
